import { useFeature } from "flagged"

import { useEntitlementSwitch } from "~/Entitlements/useEntitlements"

/**
 * Hook to check if both a feature and an entitlement are enabled. Useful for
 * during a rollout where the entitlement may exist but the feature is not yet
 * enabled for everyone.
 *
 * Is set up to use switch entitlements only, not quantities
 */
export const useFeatureAndEntitlement = ({
  featureId,
  entitlementId,
}: {
  featureId: string
  entitlementId: string
}) => {
  const isFeatureEnabled = useFeature(featureId)
  const isEntitlementEnabled = useEntitlementSwitch(entitlementId)

  return !!(isFeatureEnabled && isEntitlementEnabled)
}
